import { MenuItem } from 'primeng/api'

export const DEFAULT_EXCEL_TEMPLATE = 'default';

export const TAB_MENU_ITEMS: MenuItem[] = [
  {
    id: 'all',
    label: 'All reports',
    routerLink: '/reports-list',
  },
  {
    id: 'favorites',
    label: 'Favorites',
    routerLink: '/favorites-list',
  },
  {
    id: 'my',
    label: 'My reports',
    routerLink: '/my-reports-list',
  },
  {
    id: 'scheduled',
    label: 'Scheduled reports',
    routerLink: '/scheduled-reports-list',
  },
  {
    id: 'shared',
    label: 'Shared reports',
    routerLink: '/shared-reports',
  },
  {
    id: 'sharedWithMe',
    label: 'Shared with me',
    routerLink: '/shared-with-me',
  },
  {
    id: 'templates',
    label: 'Report templates',
    routerLink: '/templates-list',
  },
  {
    id: 'excelTemplates',
    label: 'Excel templates',
    routerLink: '/excel-templates-list',
  },
  {
    id: 'audits',
    label: 'Audits',
    routerLink: '/report-audit-list',
  },
];

export const FOLDER_NAME_MAX_LENGTH: number = 255;

export const DUPLICATE_FOLDER_NAME_ERROR_MSG: string = 'A folder with this name already exists.';

export const DEFAULT_NUMBER_OF_RESULTS_REPORTS: number = 100;

export const NUMBER_OF_RESULTS_OPTIONS_REPORTS = [50, 100, 250, 500, 1000];
